module.exports = __webpack_public_path__ + "static/img/14064B_3_5_20170509_fit.6f995e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14064B_3_5_20170509_fit.png
// module id = usKx
// module chunks = 0